import { createContext, useReducer } from 'react'
import reducer from '../reducers/combinationPicker.reducer'

const initialState = {
    color: 1,
    format: 0
}

export const PickerContext = createContext()
export const PickerDispatch = createContext()

export function PickerProvider({ children }) {
    const [state, dispatch] = useReducer(reducer, initialState, () => initialState)
    return (
        <PickerContext.Provider value={state} >
            <PickerDispatch.Provider value={dispatch} >
                {children}
            </PickerDispatch.Provider>
        </PickerContext.Provider>
    )
}